module.exports = __webpack_public_path__ + "media/application/images/ui/icon-external-link-f2d3165a673100a89dae1c65aadfbb46.png";